// src/components/Dashboard/DashboardHeader.tsx
import React from 'react';

interface DashboardHeaderProps {
  userName: string;
  onLogout: () => void;
}

const DashboardHeader: React.FC<DashboardHeaderProps> = ({ userName, onLogout }) => {
  return (
    <header className="dashboard-header">
      <div className="header-content">
        <h1>🤖 Панель управления роботами</h1>
        <div className="user-info">
          <span id="userName">{userName}</span>
          <button id="logoutBtn" className="logout-btn" onClick={onLogout}>
            Выйти
          </button>
        </div>
      </div>
    </header>
  );
};

export default DashboardHeader;